<template>
  <div class="faq-and-support">
    <div class="container">
      <div class="faq-and-support__head">
        <div class="faq-and-support__head-left faq-and-support__card">
          <h1 class="faq-and-support__head-left-title">Поддержка</h1>
          <div class="faq-and-support__head-left-text">
            Мы рядом 24 часа,<br />7 дней в неделю
          </div>
        </div>
      </div>

      <FaqAndSupportContacts />
    </div>

    <FaqAndSupportDirectionsMobile />

    <div class="container">
      <FaqAndSupportChannelsTabs />
      <div class="faq-and-support__questions">
        <h2 class="faq-and-support__subtitle faq-and-support__questions-title">
          Популярные вопросы
        </h2>

        <ul class="faq-and-support__questions-list">
          <li
            v-for="item in questions"
            :key="item.id"
            class="faq-and-support__questions-list-item"
          >
            <a
              :href="item.url"
              target="_blank"
              class="faq-and-support__questions-list-item-link"
            >
              <span>{{ item.title }}</span>

              <VIconMTS
                :name="'mts/icon-mts--arrow-link'"
                class="faq-and-support__questions-list-item-link-img"
                width="16"
                height="16"
                fill="#1d2023"
              />
            </a>
          </li>
        </ul>
      </div>
      <FaqAndSupportReviews />
    </div>
  </div>
</template>

<script>
import VIconMTS from '@/components/Common/MTS/VIconMTS.vue'
import FaqAndSupportContacts from '@/components/Desktop/FaqAndSupport/Contacts/FaqAndSupportContacts.vue'
import FaqAndSupportReviews from '@/components/Desktop/FaqAndSupport/FaqAndSupportReviews.vue'
import FaqAndSupportQuestionListMixin from '@/components/Desktop/FaqAndSupport/mixins/FaqAndSupportQuestionListMixin'
import FaqAndSupportAdvantageListMixin from '@/components/Desktop/FaqAndSupport/mixins/FaqAndSupportAdvantageListMixin'
import FaqAndSupportDirectionsMobile from '@/components/Mobile/FaqAndSupport/Directions/FaqAndSupportDirectionsMobile.vue'
import FaqAndSupportChannelsTabs from '@/components/Desktop/FaqAndSupport/Channels/FaqAndSupportChannelsTabs.vue'

export default {
  name: 'FaqAndSupportMobile',
  components: {
    FaqAndSupportChannelsTabs,
    FaqAndSupportDirectionsMobile,
    FaqAndSupportReviews,
    VIconMTS,
    FaqAndSupportContacts,
  },
  mixins: [FaqAndSupportQuestionListMixin, FaqAndSupportAdvantageListMixin],
}
</script>
<style lang="scss" scoped>
.faq-and-support {
  font-family: $font-mts-compact;
  padding: 38px 0 32px;

  .container {
    padding: 0 20px;
  }

  &__card {
    display: block;
    border-radius: 24px;
    background: $color-white;
    overflow: hidden;
  }

  &__subtitle {
    font-family: $font-mts-wide;
    font-size: 32px;
    font-weight: 500;
    line-height: 38px;
    letter-spacing: -0.32px;
    text-align: center;
  }

  &__head {
    display: grid;
    grid-template-columns: 1fr;
    gap: 16px;
    margin-bottom: 16px;

    &-left {
      color: $color-dark-2;
      padding: 24px;
      min-height: 339px;
      background: $color-white
        url('~assets/img/faq_and_support/background-card.svg') no-repeat 100%
        100%;

      @include screen-down('sm') {
        background: $color-white
          url('~assets/img/faq_and_support/background-card.svg') no-repeat 120%
          100%;
      }

      &-title {
        font-size: 36px;
        font-weight: 500;
        line-height: 40px;
        margin-bottom: 16px;
      }

      &-text {
        font-size: 24px;
        font-weight: 400;
        line-height: 32px;
      }
    }
  }

  &__questions {
    &-title {
      margin-bottom: 20px;
      text-align: center;
    }

    &-list {
      display: grid;
      grid-template-columns: 1fr;
      gap: 16px;
      list-style-type: none;

      @include screen-up('sm') {
        grid-template-columns: 1fr 1fr;
      }

      &-item {
        padding: 24px 24px 36px;
        min-height: 200px;
        background: $color-white;
        border-radius: 24px;

        &-link {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          height: 100%;
          text-decoration: none;
          color: inherit;
          font-family: $font-mts-wide;
          font-size: 18px;
          font-weight: 500;
          line-height: 25px;
          letter-spacing: -0.18px;
        }
      }
    }
  }
}
</style>
